"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAll = getAll;
async function getAll(clubRepo, page = 1, pageSize = 10) {
    return await clubRepo.getAll(page, pageSize);
}
